import React from 'react';
import Script from 'next/script';
import { useAmp } from 'next/amp';

const Scripts = () => {
  const isAmp = useAmp();
  const isProductionBuild = process.env.NEXT_PUBLIC_BUILD_ENV === 'production';

  return (
    <>
      {!isAmp && isProductionBuild && (
        <Script
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-WVJ2SSM');`,
          }}
        />
      )}
    </>
  );
};

export default Scripts;
